import { render, staticRenderFns } from "./InformacionGeneralForm.vue?vue&type=template&id=f70ac290&scoped=true&"
import script from "./InformacionGeneralForm.vue?vue&type=script&lang=ts&"
export * from "./InformacionGeneralForm.vue?vue&type=script&lang=ts&"
import style0 from "./InformacionGeneralForm.vue?vue&type=style&index=0&id=f70ac290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70ac290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f70ac290', component.options)
    } else {
      api.reload('f70ac290', component.options)
    }
    module.hot.accept("./InformacionGeneralForm.vue?vue&type=template&id=f70ac290&scoped=true&", function () {
      api.rerender('f70ac290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EnvioInformacion/InformacionGeneralForm.vue"
export default component.exports